import { gateway } from "../../../gateway";

export const changeOrder = async (uids: string[]) => {
    const response = await gateway.patch(`/users/admins/order`, { uids });
    return response?.data || response?.data?.data;
}